import { StackScreenProps } from "@react-navigation/stack";
import { AddGiftCardProductCartRootParamList } from "../../../../types";
import { useTranslation } from "../../../../utilities/i18n";
import {
  Button,
  Label,
  Page,
  Stack,
  TextField,
  useFlashMessages,
} from "@towersystems/roam-common-native";
import React from "react";
import { isValidMoneyValue } from "../../../../utilities/is-valid-money";
import { View } from "react-native-ui-lib";
import { useAddGiftCardProductScreenProvider } from "./hooks";
import { useMutation } from "@apollo/client";
import { MUTATION_GENERATE_INACTIVE_GIFT_CARD } from "../../../../utilities/gift-card/constants";
import { GiftCard } from "@towersystems/roam-common/lib/generated-types";
import { useAddItem } from "../../utils/sale-controller";

export interface GenerateGiftCardCodeScreenProps
  extends StackScreenProps<
    AddGiftCardProductCartRootParamList,
    "GenerateGiftCardCodeScreen"
  > {}

export const GenerateGiftCardCodeScreen = ({
  navigation,
  route,
}: GenerateGiftCardCodeScreenProps) => {
  const { t } = useTranslation("gift_card");
  const flashMessagesContext = useFlashMessages();
  const { productId } = useAddGiftCardProductScreenProvider();
  const addItem = useAddItem({ navigation: navigation });

  const [cardAmount, setCardAmount] = React.useState<string | undefined>(
    undefined
  );

  const [m] = useMutation<{ generateGiftCard: GiftCard }>(
    MUTATION_GENERATE_INACTIVE_GIFT_CARD
  );

  const isValidAmount = React.useMemo(() => {
    if (!cardAmount) {
      return false;
    }
    if (!isValidMoneyValue(cardAmount)) {
      return false;
    }

    // check if is positive number and not zero
    if (parseFloat(cardAmount) <= 0) {
      return false;
    }

    return true;
  }, [cardAmount]);

  const handleOnSetCardAmount = React.useCallback(
    (amount: string) => {
      setCardAmount(amount);
    },
    [setCardAmount]
  );

  const handleOnGenerateGiftCArd = React.useCallback(
    (productId: string, amount: number) => {
      m()
        .then(async (res) => {
          if (res.data?.generateGiftCard) {
            await addItem(productId, {
              giftCardNumber: res.data.generateGiftCard.code,
              basePrice: amount,
            });
            navigation.getParent()?.goBack();
          } else {
            throw new Error("Failed to generate gift card");
          }
        })
        .catch((err) => {
          flashMessagesContext.showMessage({
            message: "Failed to generate gift card",
            severity: "error",
          });
        });
      console.log("FINDME, productId, amount", productId, amount);
    },
    []
  );

  const inputMarkup = (
    <View>
      <Label label={t("form.gift_card_value.label")} />
      <TextField
        placeholder={t("form.gift_card_value.placeholder")}
        onChangeText={handleOnSetCardAmount}
        value={cardAmount}
        formatterType={isValidAmount ? "money" : undefined}
        validationMessage={
          cardAmount && !isValidAmount ? "Invalid amount" : undefined
        }
      />
    </View>
  );

  const buttonMarkup = (
    <Button
      label={t("button.generate_gift_card")}
      disabled={!isValidAmount}
      onPress={() => {
        if (cardAmount && isValidMoneyValue(cardAmount)) {
          handleOnGenerateGiftCArd(productId, parseFloat(cardAmount));
        }
      }}
      fullWidth
      isAction
    />
  );
  return (
    <Page
      title={t("title.generate_gift_card")}
      secondaryTitle={t("title.generate_gift_card_secondary")}
      footer={buttonMarkup}
    >
      <Stack vertical>{inputMarkup}</Stack>
    </Page>
  );
};
